// Revenue value (USD) at/above which a recommendation renders an absolute
// dollar figure instead of a percentage (PromoCard, homepage banner, and the
// action-center nav popover all share this threshold).
export const REVENUE_THRESHOLD = 4000;

// sessionStorage key marking that the action-center nav popover was already
// shown this session (frequency: once per session).
export const ACTION_CENTER_POPOVER_SEEN_KEY = "actionCenterPopoverSeen";
